import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Dropdown from '../common/Dropdown';
import { MenuOption } from '../common/MenuOption';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import { push } from 'react-router-redux';

class AdminToolbar extends React.PureComponent<DispatchProps & RouteComponentProps> {
    private menuElements: MenuOption[] = [
        { text: 'Admin', route: '/admin' },
        { text: 'Manage Customers', route: '/admin/customers' },
        { text: 'Estimation periods', route: '/admin/estimation-periods' },
        { text: 'Integration panel', route: '/admin/integration-panel' },
        { text: 'Logout', route: '/logout' }
    ];

    public render(): JSX.Element {
        return (
            <Dropdown
                placeholder="admin"
                onChange={this.onSelect}
                options={this.menuElements.map((menuOption: MenuOption) => menuOption.text)}
                class="navbar-select"
                color="white"
            />
        );
    }

    private onSelect = (value: HTMLSelectElement['value']): void => {
        const selectedOption: MenuOption | undefined = this.menuElements.find((menuOption: MenuOption) => menuOption.text === value);
        if (selectedOption) {
            this.props.dispatch(push(selectedOption.route));
        }
    };
}

export default connect(mapDispatchToProps)(withRouter(AdminToolbar));



// WEBPACK FOOTER //
// ./src/view/admin/AdminToolbar.tsx